/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRequestBody
 */
export interface CreateRequestBody {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRequestBody
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestBody
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestBody
     */
    proxyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestBody
     */
    proxyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestBody
     */
    sftpUsername: string;
}

/**
 * Check if a given object implements the CreateRequestBody interface.
 */
export function instanceOfCreateRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "sftpUsername" in value;

    return isInstance;
}

export function CreateRequestBodyFromJSON(json: any): CreateRequestBody {
    return CreateRequestBodyFromJSONTyped(json, false);
}

export function CreateRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': json['active'],
        'id': json['id'],
        'name': json['name'],
        'proxyId': !exists(json, 'proxy_id') ? undefined : json['proxy_id'],
        'proxyName': !exists(json, 'proxy_name') ? undefined : json['proxy_name'],
        'sftpUsername': json['sftp_username'],
    };
}

export function CreateRequestBodyToJSON(value?: CreateRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'id': value.id,
        'name': value.name,
        'proxy_id': value.proxyId,
        'proxy_name': value.proxyName,
        'sftp_username': value.sftpUsername,
    };
}

